import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  employeeRewardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    filters: {},
    error: null,
    success: false,
  },

  employeeRewardDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },

  leaderboardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    filters: {},
    error: null,
    success: false,
  },
  dashboardStats: {
    requesting: false,
    data: null,
    error: null,
  },
  myRewardSummary: {
  requesting: false,
  data: {
    balance: 0,
    percentile: 0,   
    activities: [],
    today_rewards: [] 
  },
  error: null,
  success: false
}
}

export const employeeRewardSlice = createSlice({
  name: 'employeeReward',
  initialState,
  reducers: {

    getEmployeeRewardList: (state, action) => {
      state.employeeRewardList.requesting = true
      state.employeeRewardList.error = null
      state.employeeRewardList.success = false
      state.employeeRewardList.filters = action.payload
    },

    getEmployeeRewardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload

      state.employeeRewardList.requesting = false
      state.employeeRewardList.items = data || []
      state.employeeRewardList.success = true

      state.employeeRewardList.pagination.current_page = current_page
      state.employeeRewardList.pagination.per_page = per_page
      state.employeeRewardList.pagination.total = total
    },

    getEmployeeRewardListFail: (state, action) => {
      state.employeeRewardList.requesting = false
      state.employeeRewardList.error = action.payload
    },

    getEmployeeRewardDetails: (state) => {
      state.employeeRewardDetails.requesting = true
      state.employeeRewardDetails.error = null
      state.employeeRewardDetails.data = null
      state.employeeRewardDetails.success = false
    },

    getEmployeeRewardDetailsSuccess: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.data = action.payload
      state.employeeRewardDetails.success = true
    },

    getEmployeeRewardDetailsFail: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.error = action.payload
    },

    doEmployeeRewardCreate: (state) => {
      state.employeeRewardDetails.requesting = true
      state.employeeRewardDetails.error = null
      state.employeeRewardDetails.success = false
    },

    doEmployeeRewardCreateSuccess: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.data = action.payload
      state.employeeRewardDetails.success = true
    },

    doEmployeeRewardCreateFail: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.error = action.payload
      state.employeeRewardDetails.success = false
    },

    doEmployeeRewardUpdate: (state) => {
      state.employeeRewardDetails.requesting = true
    },

    doEmployeeRewardUpdateSuccess: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.data = action.payload
      state.employeeRewardDetails.success = true
    },

    doEmployeeRewardUpdateFail: (state, action) => {
      state.employeeRewardDetails.requesting = false
      state.employeeRewardDetails.error = action.payload
      state.employeeRewardDetails.success = false
    },

    doEmployeeRewardDelete: (state) => {
      state.employeeRewardDetails.requesting = true
      state.employeeRewardDetails.error = null
    },

    doEmployeeRewardReset: (state) => {
      state.employeeRewardDetails.data = null
      state.employeeRewardDetails.error = null
      state.employeeRewardDetails.success = false
    },

    getEmployeeRewardLeaderboard: (state, action) => {
      state.leaderboardList.requesting = true;
      state.leaderboardList.error = null;
      state.leaderboardList.success = false;
      state.leaderboardList.filters = action.payload;
    },

    getEmployeeRewardLeaderboardSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload;

      state.leaderboardList.requesting = false;
      state.leaderboardList.items = data || [];
      state.leaderboardList.success = true;

      state.leaderboardList.pagination.current_page = current_page;
      state.leaderboardList.pagination.per_page = per_page;
      state.leaderboardList.pagination.total = total;
    },

    getEmployeeRewardLeaderboardFail: (state, action) => {
      state.leaderboardList.requesting = false;
      state.leaderboardList.error = action.payload;
    },

    getEmployeeRewardDashboard: (state) => {
      state.dashboardStats.requesting = true
      state.dashboardStats.error = null
    },

    getEmployeeRewardDashboardSuccess: (state, action) => {
      state.dashboardStats.requesting = false
      state.dashboardStats.data = action.payload
    },

    getEmployeeRewardDashboardFail: (state, action) => {
      state.dashboardStats.requesting = false
      state.dashboardStats.error = action.payload
    },
    
    getMyRewardSummary: (state) => {
      state.myRewardSummary.requesting = true;
      state.myRewardSummary.error = null;
      state.myRewardSummary.success = false;
    },

    getMyRewardSummarySuccess: (state, action) => {
      state.myRewardSummary.requesting = false;
      state.myRewardSummary.data = action.payload;
      state.myRewardSummary.success = true;
    },

    getMyRewardSummaryFail: (state, action) => {
      state.myRewardSummary.requesting = false;
      state.myRewardSummary.error = action.payload;
      state.myRewardSummary.success = false;
    },
  },
})

export const {
  getEmployeeRewardList, getEmployeeRewardListSuccess,
  getEmployeeRewardListFail, getEmployeeRewardDetails,
  getEmployeeRewardDetailsSuccess, getEmployeeRewardDetailsFail, 
  doEmployeeRewardCreate, doEmployeeRewardCreateSuccess, 
  doEmployeeRewardCreateFail, doEmployeeRewardUpdate, 
  doEmployeeRewardUpdateSuccess, doEmployeeRewardUpdateFail, 
  doEmployeeRewardDelete, doEmployeeRewardReset,
  getEmployeeRewardLeaderboard, getEmployeeRewardLeaderboardSuccess,
  getEmployeeRewardLeaderboardFail,
  getEmployeeRewardDashboard, getEmployeeRewardDashboardSuccess,
  getEmployeeRewardDashboardFail, getMyRewardSummary,
  getMyRewardSummarySuccess, getMyRewardSummaryFail,
} = employeeRewardSlice.actions

export default employeeRewardSlice.reducer